export const TRANSLATIONS_ES_SETTINGS_MICROSOFT = {
  "settings.microsoft.connect_button": "Conectar Microsoft",
  "settings.microsoft.connecting": "Conectando...",
  "settings.microsoft.connected_success": "Conexión con Microsoft completada.",
  "settings.microsoft.loading_status": "Cargando estado de Microsoft...",
  "settings.microsoft.no_accounts": "No hay cuentas Microsoft conectadas.",
  "settings.microsoft.selected_account": "Cuenta seleccionada",
  "settings.microsoft.select_account": "Selecciona una cuenta",
  "settings.microsoft.unnamed_account": "Cuenta sin nombre",
  "settings.microsoft.email_unavailable": "Correo no disponible",
  "settings.microsoft.invalid_account": "Identidad de cuenta inválida. Las acciones están deshabilitadas.",
  "settings.microsoft.malformed_status": "La respuesta de estado de Microsoft es inválida. Las acciones están deshabilitadas.",
  "settings.microsoft.status_error": "No se pudo cargar el estado de Microsoft.",
  "settings.microsoft.connect_error": "No se pudo completar la autenticación de Microsoft.",
  "settings.microsoft.disconnect_error": "No se pudo desconectar la cuenta Microsoft.",
  "settings.microsoft.default_error": "No se pudo establecer la cuenta Microsoft por defecto.",
  "settings.microsoft.reauthorize_error": "No se pudo reautorizar la cuenta Microsoft.",
  "settings.microsoft.popup_blocked": "El navegador bloqueó la ventana emergente. Permite popups para continuar.",
  "settings.microsoft.sync_period_saved": "Fecha de inicio de sincronización guardada.",
  "settings.microsoft.sync_period_error": "No se pudo guardar la fecha de inicio de sincronización.",
  "settings.microsoft.sync_period_integer_error": "Selecciona una fecha válida.",
  "settings.microsoft.sync_period_range_error": "Selecciona una fecha entre hace 365 días y hoy.",
  "settings.microsoft.save_sync_period": "Guardar fecha",
  "settings.microsoft.make_default": "Hacer predeterminada",
  "settings.microsoft.reauthorize": "Reautorizar",
  "settings.microsoft.disconnect": "Desconectar",
  "settings.microsoft.oauth_processing": "Procesando autenticación de Microsoft...",
  "settings.microsoft.mail_preview_title": "Vista previa de correo",
  "settings.microsoft.drive_preview_title": "Vista previa de Drive",
  "settings.microsoft.sharepoint_preview_title": "Vista previa de SharePoint",
  "settings.microsoft.no_preview_items": "No hay elementos para mostrar.",
  "settings.microsoft.table.account": "Cuenta",
  "settings.microsoft.table.status": "Estado",
  "settings.microsoft.table.sync_period": "Sincronizar desde",
  "settings.microsoft.table.default": "Por defecto",
  "settings.microsoft.table.actions": "Acciones",
  "settings.microsoft.connected": "Conectado",
  "settings.microsoft.connection_status_title": "Estado de conexión",
  "settings.microsoft.sync_process_title": "Sincronización de cuenta",
  "settings.microsoft.sync.mail_sync_status": "Estado sincronización correo",
  "settings.microsoft.sync.drive_sync_status": "Estado sincronización drive",
  "settings.microsoft.sync.last_mail_sync_at": "Última sincronización de correo",
  "settings.microsoft.sync.last_drive_sync_at": "Última sincronización de drive",
  "settings.microsoft.sync.last_read_email_date": "Fecha del último correo sincronizado",
  "settings.microsoft.sync.last_sync_date": "Última sincronización",
  "settings.microsoft.sync.emails_processed": "Correos procesados",
  "settings.microsoft.sync.period": "Periodo a sincronizar",
  "settings.microsoft.sync.not_set": "No definido",
  "settings.microsoft.sync.all": "Todos",
  "settings.microsoft.diagnostics_title": "Diagnóstico y pruebas",
  "settings.microsoft.audit_title": "Auditoría y seguridad",
  "settings.microsoft.manage_access_link": "Gestionar permisos de cuenta Microsoft",
  "settings.microsoft.privacy_policy": "Política de privacidad",
  "settings.microsoft.terms_of_service": "Términos del servicio",
  "settings.microsoft.preview_unavailable": "Vista previa no disponible. El endpoint backend aún no está activo.",
  "settings.microsoft.no_mail_items": "No hay correos para mostrar.",
  "settings.microsoft.no_drive_items": "No hay archivos de OneDrive para mostrar.",
  "settings.microsoft.no_sharepoint_items": "No hay archivos de SharePoint para mostrar.",
  "settings.microsoft.table.subject": "Asunto",
  "settings.microsoft.table.from": "De",
  "settings.microsoft.table.received_at": "Recibido",
  "settings.microsoft.table.name": "Nombre",
  "settings.microsoft.table.type": "Tipo",
  "settings.microsoft.table.size": "Tamaño",
  "settings.microsoft.table.modified": "Modificado",
  "settings.microsoft.table.location": "Ubicación",
  "settings.microsoft.table.time": "Hora",
  "settings.microsoft.table.message": "Mensaje",
  "settings.microsoft.table.scopes": "Permisos",
  "settings.microsoft.mail_reauth_required": "Esta cuenta requiere reautorización para cargar correos.",
  "settings.microsoft.drive_reauth_required": "Esta cuenta requiere reautorización para cargar archivos.",
  "settings.microsoft.reauthorize_preview": "Reautorizar",
  "settings.microsoft.mail_not_found": "Cuenta Microsoft no encontrada. Revisa la configuración.",
  "settings.microsoft.drive_not_found": "Drive de Microsoft no encontrado.",
  "settings.microsoft.table.body_preview": "Vista previa",
  "settings.microsoft.table.has_attachments": "Adjuntos",
  "settings.microsoft.table.created_by": "Creado por",
};
